"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsUSBComponents = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _DmsExport = require("../DmsExport/DmsExport");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
var _HttpStatus = require("../../constants/HttpStatus");
var _Permissions = require("../../constants/Permissions");
var _ToggleOn = _interopRequireDefault(require("@mui/icons-material/ToggleOn"));
var _ToggleOff = _interopRequireDefault(require("@mui/icons-material/ToggleOff"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsUSBComponents = () => {
  const table = (0, _react.useRef)(null);
  const token = (0, _DmsTokenHook.getToken)();
  const onToggleStatus = async item => {
    const res = await (0, _DmsFetch.fetchData)('/usb_component/toggle/' + item.pk, 'PUT', token);
    if (res.status == _HttpStatus.HTTP_STATUS.OK_200) table.current.updateTable();else {
      console.log(res);
    }
  };
  const header = [{
    label: 'status',
    column_name: "status",
    filter: false,
    control: 'switch',
    function: (value, item) => {
      return /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
        onClick: () => onToggleStatus(item),
        icon: value == 1 ? /*#__PURE__*/_react.default.createElement(_ToggleOn.default, null) : /*#__PURE__*/_react.default.createElement(_ToggleOff.default, null),
        variant: value == 1 ? 'success' : 'danger'
      });
    }
  }, {
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Port").d("Port"),
    column_name: "port",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("UUID").d("UUID"),
    column_name: "uuid",
    filter: true,
    can_edit: false
  }, {
    label: _reactIntlUniversal.default.get("Type").d("Type"),
    column_name: "component_type",
    form_column_name: "component_type_pk",
    function: type => (type || {}).name,
    control: 'select',
    url: "/component_type/all",
    properties: {
      form_value: "pk",
      column_name: "name",
      text_template: '{name}',
      filter: {
        value: 'pk',
        field: 'component_type_pk'
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Parent").d("Parent"),
    column_name: "parent",
    control: 'select',
    url: "/component/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: "name",
      text_template: '{name}',
      filter: {
        value: 'pk',
        field: 'parent_pk'
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: _Permissions.Permissions.CAN_EDIT_COMPONENT,
    width: "80px",
    sortable: false,
    element: row => {
      const usb_component_name = row.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateUSBComponent", {
          usb_component_name
        }).d("Update {usb_component_name}"),
        url: "/usb_component",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteUSBComponent", {
          usb_component_name
        }).d("Delete {usb_component_name}"),
        text: _reactIntlUniversal.default.get("DeleteUSBComponentMessage", {
          usb_component_name
        }).d("The component {usb_component_name} will be deleted. Are you sure about it?"),
        url: "/usb_component",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_COMPONENT
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateComponent").d("Create component"),
    url: "/usb_component",
    header: header,
    variant: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "/usb_component/table",
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar
  }));
};
exports.DmsUSBComponents = DmsUSBComponents;